<template>
  <base-section
    id="affiliates"
    class="grey lighten-4"
    space="36"
  >
    <v-container>
      <base-section-heading title="Наши партнеры" />

      <v-slide-group>
        <template v-for="(partner, i) in partners">
          <v-slide-item
            :key="partner.name"
            class="align-self-center"
          >
            <a :href="partner.url" target="_blank" rel="external">
              <base-img
                  :src="require(`@/assets/pe/${partner.logo}`)"
                  color="grey"
                  contain
                  height="40"
                  width="128"
              />
            </a>
          </v-slide-item>

          <v-responsive
            v-if="i < partners.length - 1"
            :key="`divider-${i}`"
            class="text-center"
            height="56"
            width="48"
          >
            <v-divider vertical />
          </v-responsive>
        </template>
      </v-slide-group>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAffiliates',
    data: () => ({
      partners: [
        {
          name: 'Buderus',
          logo: 'logo-1.png',
          url: '//www.buderus.com/tr/en/'
        },
        {
          name: 'ICI Caldaie',
          logo: 'logo-2.png',
          url: '//www.icicaldaie.com'
        },
        {
          name: 'Viessmann',
          logo: 'logo-3.png',
          url: '//www.viessmann.com'
        },
        {
          name: 'Loos',
          logo: 'logo-4.png',
          url: '//www.loos.at'
        },
      ]
    })
  }
</script>
